import { render, staticRenderFns } from "./MembersHeader.vue?vue&type=template&id=4a0c6ffe&scoped=true"
import script from "./MembersHeader.vue?vue&type=script&lang=js"
export * from "./MembersHeader.vue?vue&type=script&lang=js"
import style0 from "./MembersHeader.vue?vue&type=style&index=0&id=4a0c6ffe&prod&scoped=true&lang=css"
import style1 from "./MembersHeader.vue?vue&type=style&index=1&id=4a0c6ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c6ffe",
  null
  
)

export default component.exports